(() => {
  let lenis;
  let animationFrame;

  const updateHeroParallax = () => {
    const hero = document.querySelector('[data-sembonia-hero]');
    if (!hero) return;

    const rect = hero.getBoundingClientRect();
    const progress = Math.min(Math.max(-rect.top / Math.max(rect.height, 1), 0), 1);
    hero.style.setProperty('--sembonia-parallax-y', `${progress * 12}vh`);
  };

  const queueHeroParallax = () => {
    if (animationFrame) return;
    animationFrame = window.requestAnimationFrame(() => {
      animationFrame = undefined;
      updateHeroParallax();
    });
  };

  const destroyLenis = () => {
    if (lenis) {
      lenis.destroy();
      lenis = undefined;
    }
  };

  const initialize = () => {
    destroyLenis();

    // Run Lenis regardless of reduced-motion preference, as requested.
    if (!window.Shopify?.designMode && window.Lenis) {
      lenis = new window.Lenis({
        // Verified against the live Framer component: intensity 30 / 10 = 3s.
        duration: 3,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        // Lenis 1.3.26 also has its own reduced-motion safeguard.
        respectReducedMotion: false,
        smoothWheel: true,
        wheelMultiplier: 1,
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        syncTouch: false,
        autoRaf: true,
        autoToggle: true,
        allowNestedScroll: true,
        stopInertiaOnNavigate: true
      });
      lenis.on('scroll', queueHeroParallax);
      window.semboniaLenis = lenis;
    }

    updateHeroParallax();
  };

  window.addEventListener('scroll', queueHeroParallax, { passive: true });
  window.addEventListener('resize', queueHeroParallax, { passive: true });
  document.addEventListener('shopify:section:load', queueHeroParallax);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
